import { CheckCircle } from "@phosphor-icons/react";

/**
 * Terminal SUCCESS step of the Pay wizard. Shown after a successful
 * tokenization/charge. Purely presentational.
 */
const SuccessStep = ({ total, loyaltyMember, pointsAwarded }) => (
  <div className="py-12 text-center" data-testid="wizard-success-step">
    <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <CheckCircle size={48} weight="fill" className="text-green-600" />
    </div>
    <p className="text-lg font-medium">Thank you!</p>
    <p className="text-muted-foreground">Payment of ${total.toFixed(2)} received</p>
    {loyaltyMember && (
      <p className="text-sm text-accent mt-1">
        {pointsAwarded} points awarded to {loyaltyMember.name}
      </p>
    )}
  </div>
);

export default SuccessStep;
